module.exports = __webpack_public_path__ + "static/media/sort.5a918d85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sort.svg
// module id = 883
// module chunks = 0